<div class="mt-16 grid grid-cols-12 flex-col text-tertiary-900">
    <section class="col-span-12 text-2xl text-center">
        <span>Application preparation complete.</span>
    </section>
    <section class="col-span-12 w-full">
        <app-submit-to-ewa-form-submission
            (submitForm)="handoverToEwaSubmission()"
            [showDisclaimer]="false"
            [submitButtonLabel]="'Save & Complete'"
        >
        </app-submit-to-ewa-form-submission>
    </section>
</div>
